import initialState from './ChainsInitialState';
import reducers from './ChainsReducer';

export default {
  initialState,
  reducers,
};
